import type { Product } from "@little-finds/core";
export function ProductArt({
  product,
  size = 44,
}: {
  product: Product;
  size?: number;
}) {
  const { illustration: kind, color } = product;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={`${product.name} illustration`}
    >
      <g
        stroke="#4d5049"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {kind === "popsicle" ? (
          <>
            <path d="M19 40V18q0-12 13-12t13 12v22q-13 5-26 0" fill={color} />
            <path d="M28 44v11q4 6 8 0V44" fill="#d8bc89" />
            <path d="M25 17v11" stroke="#fff" opacity=".6" />
          </>
        ) : kind === "cube" ? (
          <>
            <path d="m12 22 20-11 21 11-1 24-20 12-20-12Z" fill={color} />
            <path d="m12 22 20 11 21-11M32 33v25" fill="none" />
            <path d="m20 23 10-6" stroke="#fff" strokeWidth="3" />
          </>
        ) : kind === "peanut" ? (
          <>
            <path
              d="M34 8c-19-8-27 8-17 21-17 20 5 31 17 24 22-3 13-19 9-23 10-11 8-23-9-22Z"
              fill={color}
            />
            <path
              d="m19 18 17 3m-15 18 18 2m-14-10 3 18m4-36 3 16"
              fill="none"
              opacity=".35"
            />
            <path d="m23 54-4 5m18-6 4 6" strokeWidth="4" />
          </>
        ) : ["octopus", "jelly"].includes(kind) ? (
          <>
            <path d="M15 34V25q0-19 18-19t18 19v9" fill={color} />
            <path
              d="M15 29q-12 10-2 23 6 7 9-7 3 19 9 9 4-10 5-6 7 19 11 1 12 13 11-4-1-10-10-14"
              fill={color}
            />
            <path d="M23 17q4-6 10-6" stroke="#fff" opacity=".6" />
          </>
        ) : kind === "dragon" ? (
          <>
            <path
              d="m22 14-2-9 12 6 9-7 1 15 10 8-4 16-15 7-19-5-7-13 9-9Z"
              fill={color}
            />
            <path
              d="m38 41 16 6-7 8-15-6M19 43l-6 11 15-2M43 26l12-10-1 21"
              fill={color}
            />
            <path d="m27 10 4 6 4-6" fill="#e9d9ac" />
          </>
        ) : kind === "coral" ? (
          <path
            d="M27 55V35L16 28V12q-8-5-8 2v20l17 10v11Zm8 0V29l13-5V11q7-5 8 2v18l-14 5v19ZM27 34V10q6-8 8 0v24"
            fill={color}
          />
        ) : kind === "cat" ? (
          <>
            <path
              d="m15 25-1-17 15 10 10-2L51 7v22q11 27-19 29T15 25Z"
              fill={color}
            />
            <path d="m15 39-8-3m8 9-9 1m42-8 9-4m-7 10 9 1" />
          </>
        ) : (
          <>
            <rect x="12" y="17" width="42" height="36" rx="13" fill={color} />
            <path d="M22 17V11q10-9 20 0v6" fill="none" />
          </>
        )}
        <circle cx="27" cy="29" r="1.7" fill="#4d5049" stroke="none" />
        <circle cx="38" cy="29" r="1.7" fill="#4d5049" stroke="none" />
        <path d="M30 35q3 3 6 0" fill="none" />
        {product.category === "bag_charm" && (
          <circle
            cx="51"
            cy="9"
            r="6"
            fill="none"
            stroke="#a89875"
            strokeWidth="3"
          />
        )}
      </g>
    </svg>
  );
}
